import * as React from 'react';

const SvgPlayFill = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.478 6.478 2 12 2c5.523 0 10 4.478 10 10 0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10Zm13.246-.6-4.64-2.866c-.55-.34-1.306.007-1.306.6v5.732c0 .593.756.94 1.306.6l4.64-2.866c.472-.291.472-.909 0-1.2Z", fill: "currentColor" })));

export { SvgPlayFill as default };
